import React, {useState, useContext} from "react"
import {IEligibilityApplication} from "models/IEligibilityApplication"
import {IEligibilityOutcome} from "models/IEligibilityOutcome"

export interface IEligibilityApplicationContext {
  eligibilityApplication: IEligibilityApplication | undefined
  setEligibilityApplication: (
    eligibilityApplication: IEligibilityApplication
  ) => void
  eligibilityOutcome: IEligibilityOutcome | undefined
  setEligibilityOutcome: (eligibilityOutcome: IEligibilityOutcome) => void
}

export type IEligibilityApplicationProvider = {
  children: React.ReactNode
}

const EligibilityApplicationContext =
  React.createContext<IEligibilityApplicationContext>(
    {} as IEligibilityApplicationContext
  )

export const EligibilityApplicationProvider = ({
  children
}: IEligibilityApplicationProvider) => {
  const [activeEligibilityApplication, setActiveEligibilityApplication] =
    useState<IEligibilityApplication | undefined>(undefined)
  const [activeEligibilityOutcome, setActiveEligibilityOutcome] = useState<
    IEligibilityOutcome | undefined
  >(undefined)

  const setEligibilityApplication = (
    eligibilityApplication: IEligibilityApplication
  ) => {
    setActiveEligibilityApplication(eligibilityApplication)
  }

  const setEligibilityOutcome = (eligibilityOutcome: IEligibilityOutcome) => {
    setActiveEligibilityOutcome(eligibilityOutcome)
  }

  const value: IEligibilityApplicationContext = {
    eligibilityApplication: activeEligibilityApplication,
    setEligibilityApplication,
    eligibilityOutcome: activeEligibilityOutcome,
    setEligibilityOutcome
  }

  return (
    <EligibilityApplicationContext.Provider value={value}>
      {children}
    </EligibilityApplicationContext.Provider>
  )
}

export const useEligibilityApplication = (): IEligibilityApplicationContext =>
  useContext(EligibilityApplicationContext)
